/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDomainFiling = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4.252 10h1.93a14.724 14.724 0 0 0-.08 4h-1.85a8.047 8.047 0 0 1 0-4zm.818-2a8.04 8.04 0 0 1 2.682-2.78c-.44.82-.827 1.76-1.125 2.78zm5.453-5.892C5.7 2.822 2 6.98 2 12c0 5.185 3.947 9.449 9 9.95v-2.012l-.02-.002A10.678 10.678 0 0 1 8.594 16H11v-2H8.119a12.642 12.642 0 0 1 .09-4H11v1h2v-1h2.766a13.169 13.169 0 0 1 .14 1h2.009c-.03-.338-.07-.672-.122-1h1.955c.084.326.148.66.19 1h2.013C21.449 5.947 17.185 2 12 2c-.5 0-.994.036-1.475.107zM11 4.185V8H8.724c.251-.74.553-1.414.88-2 .48-.857.975-1.459 1.396-1.815zM7.597 18.68A8.04 8.04 0 0 1 5.07 16H6.5c.254.905.613 1.805 1.097 2.68zM17.348 8c-.3-1.03-.693-1.978-1.137-2.803A8.04 8.04 0 0 1 18.93 8zM13 4.206c.415.359.901.954 1.37 1.794.328.586.63 1.26.881 2H13zM13 13v10h2V13zm4 0v10h2V13zm4 0v10h2V13z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDomainFiling as DomainFiling };
